export enum UserRolEnum {
    ADMIN = 'Admin',
    ALUMNO = 'User',
    TUTOR = 'Tutor',
    SUPERVISOR = 'Supervisor',
  }